import { PayloadsType } from '../utils/types';

export const Name = 'homepage-hero-images';

export type PayloadType = string;

export type VariantType = 'control' | 'test-b' | 'test-c' | 'test-d' | 'test-e';

export const Payloads: PayloadsType<PayloadType, VariantType> = {
  control: '/assets/hero-images/control.png',
  'test-b': '/assets/hero-images/test-b.png',
  'test-c': '/assets/hero-images/test-c.png',
  'test-d': '/assets/hero-images/test-d.png',
  'test-e': '/assets/hero-images/test-e.png',
};
